export default __webpack_public_path__ + "static/media/rhythm.a123c7d0.png";